import '@/assets/mcss/mbase.css'
import '@/assets/mcss/mheader.less'
import '@/assets/mcss/mfooter.less'
import '@/assets/mcss/maboutus.less'

$(".h").remove()
let newsList = $.extend(true, [], newsData)
newsList.splice(2, 0, mainNews)
console.log(newsList, '5')
let titleArr = newsList.map(v=>v.title)
// let videoArr = newsList.reduce((v,c,i) => c.haveVideo ? v.concat(i) : v, [])
let curIndex = 0 //当前新闻Index
let search = window.location.search
if (!search || search.includes('from')) {
    toggleTab(0)
}
if (search.includes('index')) {
    toggleTab(1)
    curIndex = Number(search.substring(search.lastIndexOf("=") + 1, search.length))
    console.log(curIndex)
    goNewsPage()
}

if (search.includes('join')) {
    toggleTab(0)
    console.log($(".joinUs").offset().top)
    $("html,body").animate({
        scrollTop: $(".joinUs").offset().top - 15
    }, 0)
}
if (search.includes('list')) {
    toggleTab(1)
}
//加上回到顶部按钮，及当页面存在视频时隐藏导航栏
scrollTop()

//设置底部上下页签
function setPaging(i) {
    $('.pre').html(titleArr[i - 1] || '没有啦!')
    $('.next').html(titleArr[i + 1] || '没有啦!')
}

function goNewsDetail(i) {
    window.location = `/m/aboutus.html?index=${i}`
}

function goNewsPage() {
    $('.newsDetail').addClass('news_show');
    $('.newsList').removeClass('news_show');
    // $('.newsDetail>.tpl').eq(curIndex).addClass('tpl_show');
    // $('.newsDetail>.tpl').eq(curIndex).siblings().removeClass('tpl_show');
    renderNewsDetail()
    //设置底部上下篇新闻标题
    setPaging(curIndex)
}
function renderNewsDetail () {
   let r =  newsList[curIndex]
   let s = '<h1 class="newsTitle">' + r.title.replace('<!-->', '</br>') + '</h1>'
   + '<p class="newsTime">' + r.time + '<span>新闻来源：' + r.source + '</span> </p>' 
   + r.content
   $('.tpl').html(s)
}
function toggleTab(tabIndex) {
    $('.tabUl>li').eq(tabIndex).addClass('tab');
    $('.tabUl>li').eq(tabIndex).siblings().removeClass('tab');
    $('.content>div').eq(tabIndex).addClass('div_show');
    $('.content>div').eq(tabIndex).siblings().removeClass('div_show');
    $('.bannerPic>div').eq(tabIndex).addClass('div_show');
    $('.bannerPic>div').eq(tabIndex).siblings().removeClass('div_show');
    $('.newsDetail').removeClass('news_show');
    $('.newsList').addClass('news_show');
    $('.tpl').html('')
    $('.fixed-nav').show()
}

function scrollTop() {
    $(window).scroll(function() {
        let t = $('.goTop')
        $(window).scrollTop() > 1000 ? t.fadeIn() : t.fadeOut()
        $(window).scrollTop() > $(document).height() - 1100 ? t.addClass('static') : t.removeClass('static')
        // removeNavBar()
    })
    $(".goTop").click(function() {
        $('html,body').animate({ scrollTop: 0 }, 1000); //回到顶端
        return false;
    });

}
//如果详情页有视频，则隐藏顶部tab栏 
function removeNavBar() {
    if($('#iframe').length) {
        let a = $(window).scrollTop()
        let b = $('#iframe').offset().top
        let ifShowNav = b-a > 60
        console.log(ifShowNav)
        let t = $('.fixed-nav')
        ifShowNav ? t.fadeIn() : t.fadeOut()
    }
}
// tab切换事件
$('.tabUl li').click(function(event) {
    let tabIndex = $(this).index()
    toggleTab(tabIndex)
})

//返回上一页
$('.returnList').on('click', function() {
    window.location = '/m/aboutus.html?list'
})

// 企业动态list点击事件
$('.newsContent>li').click(function(event) {
    curIndex = $(this).index()
    goNewsDetail(curIndex)
})

$('.previousText').click(function(event) {
    if (curIndex !== 0) {
        goNewsDetail(curIndex - 1)
    }
})
$('.nextText').click(function(event) {
    if (curIndex !== (titleArr.length - 1)) {
        goNewsDetail(curIndex + 1)
    }
})

// function setIframeSrc() {
//     var iframe1 = document.getElementById('iframe1');
//     if (-1 == navigator.userAgent.indexOf("MSIE")) {
//         iframe1.src = 'https://v.qq.com/txp/iframe/player.html?vid=a3020x11h6i'
//     } else {
//         iframe1.location = 'https://v.qq.com/txp/iframe/player.html?vid=a3020x11h6i'
//     }
// }
// setTimeout(setIframeSrc, 5)